import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_SIZES,
  INITIAL_PAGE,
  PAGE_PARAM_KEY,
  PAGE_SIZE_PARAM_KEY,
} from '../api/integrationsQuery';

/**
 * @returns [pageSize, pageNumber] - extracted from URLSearchParams object, under 'page' and 'pageSize' keys.
 */
export const getPaginationParamsFromSearchParams = (searchParams: URLSearchParams): [number, number] => {
  // first null check if there is no page/pageSize defined in search params
  const pageSizeQuery = Number(searchParams.get(PAGE_SIZE_PARAM_KEY) ?? DEFAULT_PAGE_SIZE);
  const pageQuery = Number(searchParams.get(PAGE_PARAM_KEY) ?? INITIAL_PAGE);

  // check if page/pageSize is valid number
  const pageSizeNumber = Number.isNaN(pageSizeQuery) ? DEFAULT_PAGE_SIZE : pageSizeQuery;
  const pageNumber = Number.isNaN(pageQuery) ? INITIAL_PAGE : pageQuery;

  // check if page is not negative number and page size is from defined page numbers
  const pageSize = DEFAULT_PAGE_SIZES.indexOf(pageSizeNumber) === -1 ? DEFAULT_PAGE_SIZE : pageSizeNumber;
  const page = pageNumber <= 0 ? INITIAL_PAGE : pageNumber;

  return [pageSize, page];
};
